export default __webpack_public_path__ + "assets/front/scss/error.fd9fd7e8bca376420261befa94b8ade6.css";